import { render, staticRenderFns } from "./AssignmentStepper.vue?vue&type=template&id=afd85180&scoped=true"
import script from "./AssignmentStepper.vue?vue&type=script&lang=js"
export * from "./AssignmentStepper.vue?vue&type=script&lang=js"
import style0 from "./AssignmentStepper.vue?vue&type=style&index=0&id=afd85180&prod&scoped=true&lang=css"
import style1 from "./AssignmentStepper.vue?vue&type=style&index=1&id=afd85180&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afd85180",
  null
  
)

export default component.exports